// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-list--three-line .v-list-item .v-list-item__subtitle[data-v-0094d2a8], .v-list-item--three-line .v-list-item__subtitle[data-v-0094d2a8] {\n  -webkit-line-clamp: 2 !important;\n}\n.v-list--three-line .v-list-item[data-v-0094d2a8], .v-list-item--three-line[data-v-0094d2a8] {\n  min-height: auto;\n}\n", ""]);
// Exports
module.exports = exports;
